// Mirror of TagBoard mobile constants (src/constants/index.ts). Kept here
// so the web app doesn't import RN-specific source. When mobile changes the
// canonical list (e.g. adds a new designation), update both — TODO P3.future:
// extract into a /shared package so they stay in sync automatically.

export const DESIGNATIONS = [
  'Operator',
  'Safety Supervisor',
  'Shift Boss',
  'Miner',
  'Electrician',
  'Mechanic',
  'Geologist',
  'Engineer',
] as const

export const CREWS = [
  'CREW_1435',
  'CREW_1436',
  'CREW_1437',
  'CREW_1438',
  'CREW_1439',
] as const

export const PERSONNEL_STATUSES = ['tagged_in', 'tagged_out', 'missing'] as const

export const EQUIPMENT_ACTIVITIES = [
  'Haul',
  'Drill',
  'Load',
  'Transport',
  'Survey',
  'Maintenance',
] as const

export const EQUIPMENT_STATUSES = ['active', 'down', 'maintenance', 'idle'] as const

export const CHAMBER_STATUSES = [
  'available',
  'full',
  'near_capacity',
  'maintenance',
] as const

export const CHAMBER_MAINTENANCE_STATUSES = [
  'operational',
  'under_maintenance',
  'needs_inspection',
  'broken',
] as const

export const LOCATION_PRIORITIES = ['CRITICAL', 'HIGH', 'MEDIUM'] as const

export const LOCATION_TYPES = [
  'entry',
  'tunnel',
  'station',
  'safety',
  'infrastructure',
  'stope',
  'surface',
] as const

export const LOCATION_MATERIALS = ['NAG', 'PAG', 'Waste'] as const
export const LOCATION_HEADING_STATUSES = ['Drill', 'Muck', 'Blast'] as const

export const AP_STATUSES = ['active', 'offline', 'fault'] as const

export const MINE_LEVELS = [
  'Level_1232',
  'Level_1500',
  'Level_2000',
  'Level_2500',
  'Level_3000',
] as const

// Validation regexes (mirror mobile's expectations).
export const MAC_REGEX = /^([0-9A-Fa-f]{2}[:-]){5}[0-9A-Fa-f]{2}$/
export const IPV4_REGEX =
  /^(25[0-5]|2[0-4]\d|[01]?\d?\d)(\.(25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/

// Mine UUID — single-mine demo. Imported from supabaseClient by callers
// that need to write rows; re-exported here for convenience in modals.
export {DEFAULT_MINE_ID} from '../app/supabaseClient'

// Generates a TEXT id compatible with TagBoard's generateId() (timestamp
// base36 + random base36). Mirrors src/utils/helpers.ts so IDs created on
// web look the same as IDs created on mobile.
export function generateId(): string {
  return (
    Date.now().toString(36) + Math.random().toString(36).substring(2, 11)
  )
}

// Generates the next semantic ID for personnel (EMP_xxx). The mobile
// equivalent suggests numbering from 235 upward; we just use a 4-digit
// random suffix to keep things simple and uncollisive with mobile-created
// rows. Supabase UNIQUE constraint will catch the rare clash.
export function suggestEmployeeId(): string {
  const n = 1000 + Math.floor(Math.random() * 9000)
  return `EMP_${n}`
}

export function suggestAssetId(): string {
  const n = 100 + Math.floor(Math.random() * 900)
  return `EQ_${n}`
}
